export class SingleWorkingDayCheckValidator {
  type: 'single_working_day';

  attribute_id: string;
}
